import { render, staticRenderFns } from "./OutlinedLabel.vue?vue&type=template&id=5f906a54&"
import script from "./OutlinedLabel.vue?vue&type=script&lang=js&"
export * from "./OutlinedLabel.vue?vue&type=script&lang=js&"
import style0 from "./OutlinedLabel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports